// extracted by mini-css-extract-plugin
module.exports = {"popoverRoot":"Notification_popoverRoot__2n8Ty","popoverPaper":"Notification_popoverPaper__3QEk0"};